import initialState from "./initialState";

export function ManageSpmlCrwmlReducer(
  state = initialState.MangeSpmlCrwmlFormValues,
  action
) {
  switch (action.type) {
    case "MANAGE_SPML_CRWML_SET":
      return action.payload;
    default:
      return state;
  }
}
